<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div
  class="side-menu"
  [class.folded]="menuFolded"
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseleave()"
  *ngIf="isUserLoggedIn"
>
  <ng-scrollbar orientation="vertical">
    <div class="side-menu-header">
      <img src="assets/logo-bold.svg" alt="logo" class="menu-logo" /> <span class="hidden-folded">T-Rex</span>
    </div>

    <ng-template ngFor let-item [ngForOf]="menu" let-i="index">
      <div
        class="side-menu-item"
        *ngIf="(item.isVisible() && item.path) || item.hasVisibleChild()"
        [ngClass]="{ 'side-menu-item-collapsable': item.childrens.length > 0, collapsed: item.collapsed }"
      >
        <span
          class="side-menu-link"
          *ngIf="!item.path && item.hasVisibleChild()"
          (click)="toggleCollapsableItems(item)"
        >
          <i [class]="'side-menu-item-icon ' + item.icon"></i>
          <span class="side-menu-title">{{ item.title }}</span>
        </span>

        <a
          *ngIf="item.path && item.isVisible()"
          class="side-menu-link"
          [routerLink]="item.path"
          routerLinkActive="active"
        >
          <i [class]="'side-menu-item-icon ' + item.icon"></i>
          <span class="side-menu-title">{{ item.title }}</span>
        </a>

        <ng-template ngFor let-subitem [ngForOf]="item.childrens" let-i="index">
          <div class="side-menu-sub-items-holder" *ngIf="subitem.isVisible()">
            <a class="side-menu-sub-item" [routerLink]="subitem.path" routerLinkActive="active">
              <span class="side-menu-title">{{ subitem.title }}</span>
            </a>
          </div>
        </ng-template>
      </div>
    </ng-template>

    <!--        <div class="side-menu-item">-->
    <!--          <a class="side-menu-link" routerLink="/home" routerLinkActive="active">-->
    <!--            <i class="side-menu-item-icon fal fa-home"></i>-->
    <!--            <span class="side-menu-title">Home</span>-->
    <!--          </a>-->
    <!--        </div>-->

    <!--        <div class="side-menu-item side-menu-item-collapsable">-->
    <!--          <span class="side-menu-link">-->
    <!--            <i class="side-menu-item-icon fal fa-cog"></i>-->
    <!--            <span class="side-menu-title">Settings</span>-->
    <!--          </span>-->
    <!--          <div class="side-menu-sub-items-holder">-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/currencies" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Currencies</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/locales" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Locales</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/industries" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">industries</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/facilities" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Facilities</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/countries" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Countries</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/users" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Users</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/roles" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Roles</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/companies" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Companies</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/types" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Types</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/venues" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Venues</span>-->
    <!--            </a>-->
    <!--            <a class="side-menu-sub-item" routerLink="/settings/websites" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Websites</span>-->
    <!--            </a>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--    <div class="side-menu-item side-menu-item-collapsable">-->
    <!--      <span class="side-menu-link">-->
    <!--        <i class="side-menu-item-icon fal fa-hotel"></i>-->
    <!--        <span class="side-menu-title">Hotels</span>-->
    <!--      </span>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/hotels" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Hotels</span>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/hotel-bookings" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Bookings</span>-->
    <!--        </a>-->
    <!--      </div>-->

    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/hotel-bookings-rooms" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">ADV Bookings</span>-->
    <!--        </a>-->
    <!--      </div>-->

    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/hotel-booking-cancellations" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Booking Cancellations</span>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="side-menu-item side-menu-item-collapsable">-->
    <!--      <span class="side-menu-link">-->
    <!--        <i class="side-menu-item-icon  fal fa-calendar-week"></i>-->
    <!--        <span class="side-menu-title">Events</span>-->
    <!--      </span>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/event-groups" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Groups</span>-->
    <!--        </a>-->
    <!--      </div>-->

    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/events" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Events</span>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--        <div class="side-menu-item side-menu-item-collapsable">-->
    <!--          <span class="side-menu-link">-->
    <!--            <i class="side-menu-item-icon fal fa-user-friends"></i>-->
    <!--            <span class="side-menu-title">Clients</span>-->
    <!--          </span>-->
    <!--          <div class="side-menu-sub-items-holder">-->
    <!--            <a class="side-menu-sub-item" routerLink="/clients" routerLinkActive="active">-->
    <!--              <span class="side-menu-title">Clients</span>-->
    <!--            </a>-->
    <!--          </div>-->
    <!--        </div>-->

    <!--    <div class="side-menu-item side-menu-item-collapsable">-->
    <!--      <span class="side-menu-link">-->
    <!--        <i class="side-menu-item-icon fal fa-hand-holding-usd"></i>-->
    <!--        <span class="side-menu-title">Sales</span>-->
    <!--      </span>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/enquiries" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Enquiries</span>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/sales" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Sales</span>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="side-menu-item side-menu-item-collapsable">-->
    <!--      <span class="side-menu-link">-->
    <!--        <i class="side-menu-item-icon fal fa-file-invoice-dollar"></i>-->
    <!--        <span class="side-menu-title">Finance</span>-->
    <!--      </span>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/invoices" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Invoices</span>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" routerLink="/payments" routerLinkActive="active">-->
    <!--          <span class="side-menu-title">Payments</span>-->
    <!--        </a>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="side-menu-item">-->
    <!--      <a class="side-menu-link" routerLink="/suppliers" routerLinkActive="active">-->
    <!--        <i class="side-menu-item-icon fal fa-users"></i>-->
    <!--        <span class="side-menu-title">Suppliers</span>-->
    <!--      </a>-->
    <!--    </div>-->
    <!--    -->
    <!--    <div class="side-menu-item">-->
    <!--      <a class="side-menu-link" href="#">-->
    <!--        <i class="side-menu-item-icon fal fa-users"></i>-->
    <!--        <span class="side-menu-title">Item</span>-->
    <!--      </a>-->
    <!--    </div>-->
    <!--    -->
    <!--    <div class="side-menu-item side-menu-item-collapsable collapsed">-->
    <!--      <span class="side-menu-link">-->
    <!--        <i class="side-menu-item-icon fal fa-hourglass"></i>-->
    <!--        <span class="side-menu-title">Item</span>-->
    <!--      </span>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" href="#">-->
    <!--          <span class="side-menu-title">Sub item</span>-->
    <!--        </a>-->
    <!--        <div class="side-menu-sub-item">-->
    <!--          <span class="side-menu-title">Sub item</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <!--    -->
    <!--    <div class="side-menu-item side-menu-item-collapsable">-->
    <!--      <span class="side-menu-link">-->
    <!--        <i class="side-menu-item-icon fal fa-hourglass"></i>-->
    <!--        <span class="side-menu-title">Item</span>-->
    <!--      </span>-->
    <!--      <div class="side-menu-sub-items-holder">-->
    <!--        <a class="side-menu-sub-item" href="#">-->
    <!--          <span class="side-menu-title">Sub item</span>-->
    <!--        </a>-->
    <!--        <div class="side-menu-sub-item">-->
    <!--          <span class="side-menu-title">Sub item</span>-->
    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    <div class="side-menu-item">-->
    <!--      <a class="side-menu-link" routerLink="/about" routerLinkActive="active">-->
    <!--        <i class="side-menu-item-icon fal fa-newspaper"></i>-->
    <!--        <span class="side-menu-title">About</span>-->
    <!--      </a>-->
    <!--    </div>-->
  </ng-scrollbar>
</div>
